import { render, staticRenderFns } from "./ComponentPlantKnowledge.vue?vue&type=template&id=06090c5f&scoped=true&"
import script from "./ComponentPlantKnowledge.vue?vue&type=script&lang=js&"
export * from "./ComponentPlantKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./ComponentPlantKnowledge.vue?vue&type=style&index=0&id=06090c5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06090c5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsItems } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VFlex,VImg,VLayout,VProgressCircular,VTab,VTabItem,VTabs,VTabsItems,VTextField})
